import React from "react";
import styled from "styled-components";
import { SectionTop, UsersCards, Button } from "../../..";
import { teamData } from "../../../../assets/data/aboutUsData";

export default function TeamSection() {
	const { boards } = teamData;

	return (
		<SectionContainer className="">
			<SectionTop heading="Team" />

			<div className="mb-5 userCardsContainer">
				<h5 className="blueCool mb-4 m-sm-5 text-center">
					Board of Directors
				</h5>

				<UsersCards data={boards} />
			</div>

			<div className="d-flex align-items-center justify-content-center">
				<Button linkTo="/about-us/our-team" alignCenter>
					See more
				</Button>
			</div>
		</SectionContainer>
	);
}

const SectionContainer = styled.section`
	.userCardsContainer {
		padding: 0 1.3rem;
	}

	@media (max-width: 768px) {
		padding-top: 2.4rem !important;
		padding-right: 0 !important;
		padding-left: 0 !important;
		margin-bottom: 0 !important;
	}
`;
